export const defaultLayout = {
  w: 5,
  h: 4,
  x: 0,
  y: 0,
  minW: 4,
  minH: 3,
  moved: false,
  static: false,
};
